export const setQueryAllAttribute = (selectors: string, attr: string, value: string) => {
    document.querySelectorAll(selectors).forEach((el: any) => {
        el.setAttribute(attr, value);
    });
};
